import capitalize from "lodash/capitalize";
import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useProfileDrawer } from "@/react/components/Drawers/ProfileDrawer";
import { ProfileHoverCard } from "@circle-react/components/Profile/HoverCard";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { getProfileLinkProps } from "@circle-react/helpers/profileHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { useHomepageContext } from "../HomepageContext";

export const PostsSection = () => {
  const { trendingPosts: posts } = useHomepageContext();
  const { show: showMemberProfileDrawer } = useProfileDrawer();

  if (posts.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(
        "sidebar__block sidebar__right trending-posts !bg-primary !border-primary block !rounded-2xl",
      )}
    >
      <div className="block__title">
        <Typography.TitleMd>
          {capitalize(t("trending_posts"))}
        </Typography.TitleMd>
      </div>
      <div className="block__content">
        <ul className="trending-posts__post-list">
          {posts.map(post => {
            const profileLinkProps = getProfileLinkProps({
              publicUid: post.author.public_uid,
              showMemberProfileDrawer: (event: any) =>
                void showMemberProfileDrawer(event),
              params: {},
            });
            return (
              <li key={post.id}>
                <div className="trending-posts__post">
                  {!post.hide_meta_info && (
                    <ProfileHoverCard
                      communityMemberId={post.author.community_member_id}
                      name={post.author.name}
                      publicUid={post.author.public_uid}
                      headline={post.author.headline}
                      avatarURL={post.author.avatar_url}
                    >
                      <div className="trending-posts__avatar">
                        <a {...profileLinkProps}>
                          <UserImage
                            src={post.author.avatar_url}
                            name={post.author.name}
                            size="10"
                          />
                        </a>
                      </div>
                    </ProfileHoverCard>
                  )}
                  <div className="trending-posts__content">
                    <Link
                      to={post.show_path}
                      className="trending-posts__post-name !text-dark overflow-anywhere"
                    >
                      {post.name}
                    </Link>
                    {!post.hide_meta_info && (
                      <a
                        {...profileLinkProps}
                        className="trending-posts__author-name !text-dark"
                      >
                        {post.author.name}
                      </a>
                    )}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
